import { ACTION } from './ac_actions';

const initialState = {
  brandList: [],
  stTypes: [
    { id: 'INVERTER', name: 'Inverter' },
    { id: 'FIXED', name: 'Fixed Speed' },
  ],
  puTypes: [
    { id: 'Water-Cooled', name: 'Water-Cooled' },
    { id: 'Air-Cooled', name: 'Air-Cooled' },
  ],
  coolingCapacityUnit: [
    { id: 'TR', name: 'TR' },
    { id: 'KBTU', name: 'Btu/h' },
    { id: 'KWTH', name: 'kWth' },
  ],
  clTypes: [
    { id: 'Air-Cooled Water Chiller', name: 'Air-Cooled Water Chiller' },
    { id: 'Water-Cooled Water Chiller', name: 'Water-Cooled Water Chiller' },
    { id: 'Single Staged Absorption Chiller', name: 'Single Staged Absorption Chiller' },
    { id: 'Double Staged Absorption Chiller', name: 'Double Staged Absorption Chiller' },
  ],
  compressorTypes: [
    { id: 'Reciprocating', name: 'Reciprocating' },
    { id: 'Screw Driven', name: 'Screw Driven' },
    { id: 'Centrifugal', name: 'Centrifugal' },
    { id: 'Scroll', name: 'Scroll' },
    { id: 'Rotary', name: 'Rotary' },
  ],
  wpTypes: [
    { id: 'Chilled Water Pump', name: 'Chilled Water Pump' },
    { id: 'Condenser Water Pump', name: 'Condenser Water Pump' },
  ],
  ahuTypes: [
    { id: 'Fan Coil Unit', name: 'Fan Coil Unit' },
    { id: 'Air Handling Unit', name: 'Air Handling Unit' },
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_AC_BRAND}_FULFILLED`:
      return {
        ...state,
        brandList: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/references/ac_reducer.js